import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export enum TariffAdjustmentTypeEnum {
  EXTRA = 'EXTRA',
  DISCOUNT = 'DISCOUNT'
}

export const tariffAdjustmentTypeEnumMap: Record<TariffAdjustmentTypeEnum, string> = {
  [TariffAdjustmentTypeEnum.EXTRA]: 'Extra',
  [TariffAdjustmentTypeEnum.DISCOUNT]: 'Discount'
}

export type TariffAdjustment = {
  type: TariffAdjustmentTypeEnum
  amount: number
  reason?: string
}

export type TariffAdjustmentInput = Pick<TariffAdjustment, 'type' | 'amount' | 'reason'>

export function createTariffAdjustment({
  enrollmentId,
  propositionId,
  ...data
}: { enrollmentId: number; propositionId: number } & TariffAdjustmentInput) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.tariffAdjustment.url, { id: enrollmentId, propositionId })
    )
    .post<void, TariffAdjustmentInput>(data)
}
